import { Component } from 'react';

export default class AbstractView extends Component {
  constructor(props) {
    super(props)
  }
}